import * as React from 'react';

/**
 *
 * @param elementRef
 * @param localActiveIndex
 */
export function useManageInertPanels(
    elementRef: React.MutableRefObject<HTMLDivElement | null>,
    localActiveIndex: number
) {
    React.useEffect(() => {
        const element = elementRef.current;
        if (!element) return;

        const tabPanels = element.querySelectorAll("[role='tabpanel']");

        tabPanels.forEach(panel => {
            panel.toggleAttribute('inert', true);
        });

        const mutatedList = Array.from(tabPanels).slice(1, -1);

        mutatedList.forEach((panel, index) => {
            const isActive = index === localActiveIndex;
            if (!isActive) return;

            panel.toggleAttribute('inert', false);
        });
    }, [elementRef, localActiveIndex]);
}
